// Extracts a YouTube video ID from any common URL format:
// - https://www.youtube.com/watch?v=VIDEO_ID
// - https://youtu.be/VIDEO_ID
// - https://youtube.com/shorts/VIDEO_ID
// - https://www.youtube.com/embed/VIDEO_ID
// - Or accepts a raw 11-char ID directly.
export function extractYouTubeId(input) {
    if (!input) return "";
    const s = String(input).trim();
    // Raw ID (YouTube IDs are 11 chars, alphanumeric + _ + -)
    if (/^[A-Za-z0-9_-]{11}$/.test(s)) return s;
    try {
        const url = new URL(s);
        const host = url.hostname.replace(/^www\./, "");
        if (host === "youtu.be") {
            return url.pathname.slice(1).split("/")[0] || "";
        }
        if (host.endsWith("youtube.com")) {
            if (url.pathname === "/watch") return url.searchParams.get("v") || "";
            const parts = url.pathname.split("/").filter(Boolean);
            // /embed/ID, /shorts/ID, /v/ID
            if (parts.length >= 2 && ["embed", "shorts", "v"].includes(parts[0])) return parts[1] || "";
        }
    } catch {
        // Not a URL — fallthrough
    }
    // Last-ditch regex extraction
    const m = s.match(/([A-Za-z0-9_-]{11})/);
    return m ? m[1] : "";
}

export function youtubeThumbnail(id) {
    return id ? `https://i.ytimg.com/vi/${id}/hqdefault.jpg` : "";
}

export function youtubeEmbedUrl(id) {
    return id ? `https://www.youtube.com/embed/${id}?rel=0` : "";
}

export function youtubeWatchUrl(id) {
    return id ? `https://www.youtube.com/watch?v=${id}` : "";
}
